import { getAxiosInstance } from "../../../api";

export const getEstimateList = async (params) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.post(
      `/back-office-billing/recheck/generate-estimate`,
      params
    );
    return res;
  } catch (error) {
    return error.response.data;
  }
};

export const getSubmitList = async (body) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.post(
      `/back-office-billing/recheck/certificate-list`,
      body
    );
    return res;
  } catch (error) {
    return error.response.data;
  }
};

export const updateInvoiceHistory = async (body) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.post(`/back-office-billing/recheck/payment`, body);
    return res;
  } catch (error) {
    return error.response.data;
  }
};

export const paymentModes = async (body) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.get(
      `/back-office-billing/recheck/payment-mode`,
      body
    );
    return res;
  } catch (error) {
    return error.response.data;
  }
};
export const generateRecheckBulkEstimate = async (body) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.post(
      `/back-office-billing/recheck/bulk-estimate`,
      body
    );
    return res;
  } catch (error) {
    return error.response.data;
  }
};
